module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag15_0744AT.cc65619f.jpg";